import {
  Button,
  Center,
  Flex,
  Paper,
  Space,
  Title,
  createStyles,
} from "@mantine/core";

import amico from "../../../assets/img/PatientNotFOund.svg";

interface PatientNotFoundProps {
  patient?: string;
  
}

const useStyles = createStyles(() => ({
  infoCard: {
    borderRadius: "8px",
    minHeight: "145px",
    flexBasis: "100%",
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "15px",
    paddingTop: "15px",
    maxHeight: "145px",
  },
  paper: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    paddingLeft: "15px",
    paddingBottom: "40px",
  },
  center: {
    width: "100%",
    height: "100%",
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    marginTop: "15px",
    fontWeight: 600,
    fontSize: "22px",
    lineHeight: "30px",
    color: "#474E5B",
  },
  title1: {
    marginTop: "15px",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "28px",
    color: "#586171",
  },
}));

export const PatientNotFound: React.FC<PatientNotFoundProps> = ({
  patient,
}) => {
  const { classes } = useStyles();

  return (
    <>
      {/* <Space h="md" /> */}
      <Paper className={classes.paper}>
        <Center className={classes.center} mt={"xl"}>
          <img src={amico} alt="" />
          <Title className={classes.title}>Data not found</Title>
          <Title className={classes.title1}>
            {patient
              ? ` ${patient} data is not available.`
              : "Currently, Questionnaire data is not available."}{" "}
          </Title>
        </Center>
      </Paper>
    </>
  );
};
